import { useQuery } from '@tanstack/react-query'

import { getBankTransfer } from '@src/api'
import { DefaultApiGetBankTransferRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchBankTransfer = (
  params: DefaultApiGetBankTransferRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId && !!params.bankTransferId,
    queryFn: () => getBankTransfer(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_BANK_TRANSFER,
      params.organizationId,
      params.bankTransferId,
    ],
  })
}
